export default __webpack_public_path__ + "img/3b29d3882d79114c5d888af0653149d7.png";